import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Pane, Button, SelectField, Text } from 'evergreen-ui';
import { computePdfDoc } from '../../utils/turniPdfCompute';
import TurniPdfPreviewArea from './TurniPdfPreviewArea';
import useWindowSize from '../../utils/useWindowSize';

export default function TurniPdfPreviewModal({ isOpen, onClose, allDays, collaboratorsList, turniData, managerFerieList, reperibilitaData }) {
  const [selectedId, setSelectedId] = useState('tutti');
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const prevUrlRef = useRef(null);
  const isMobile = useWindowSize() < 768;

  useEffect(() => {
    if (!isOpen) return;
    const filtered = selectedId === 'tutti' ? collaboratorsList : collaboratorsList.filter(u => String(u.id) === selectedId);
    if (filtered.length === 0) return;
    setLoading(true);
    const timerId = setTimeout(async () => {
      try {
        const doc = await computePdfDoc(filtered, allDays, turniData, managerFerieList, reperibilitaData);
        const url = URL.createObjectURL(doc.output('blob'));
        if (prevUrlRef.current) URL.revokeObjectURL(prevUrlRef.current);
        prevUrlRef.current = url;
        setPdfUrl(url);
      } catch (e) {
        console.error('Errore generazione PDF', e);
      } finally {
        setLoading(false);
      }
    }, 60);
    return () => clearTimeout(timerId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, selectedId]);

  useEffect(() => {
    if (!isOpen) {
      if (prevUrlRef.current) { URL.revokeObjectURL(prevUrlRef.current); prevUrlRef.current = null; }
      setPdfUrl(null);
      setSelectedId('tutti');
    }
  }, [isOpen]);

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  const handleDownload = async () => {
    const filtered = selectedId === 'tutti' ? collaboratorsList : collaboratorsList.filter(u => String(u.id) === selectedId);
    const selectedMonthStr = allDays[0]?.fullDate?.substring(0, 7);
    const doc = await computePdfDoc(filtered, allDays, turniData, managerFerieList, reperibilitaData);
    const suffisso = selectedId === 'tutti' ? 'tutti' : (filtered[0] ? `${filtered[0].nome}_${filtered[0].cognome}` : 'collaboratore');
    doc.save(`turni_${selectedMonthStr || 'mese'}_${suffisso}.pdf`);
  };

  if (!isOpen) return null;

  return createPortal(
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 500 }} />
      <div style={{ position: 'fixed', inset: 0, margin: 'auto', width: isMobile ? '99vw' : 'min(1500px, 99vw)', height: isMobile ? '95vh' : '94vh', minWidth: 280, minHeight: 300, maxWidth: '99vw', maxHeight: '97vh', resize: isMobile ? 'none' : 'both', overflow: 'hidden', background: 'white', borderRadius: 8, boxShadow: '0 8px 40px rgba(0,0,0,0.35)', zIndex: 501, display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', alignItems: 'center', padding: '10px 16px', borderBottom: '1px solid #E6E8F0', background: '#F9F9FB', flexShrink: 0, userSelect: 'none' }}>
          <span style={{ fontWeight: 600, fontSize: 14, color: '#101840' }}>Anteprima PDF — Resoconto mensile turni</span>
          <button onClick={onClose} style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, lineHeight: 1, color: '#696F8C', padding: '0 4px' }} aria-label="Chiudi">✕</button>
        </div>
        <Pane display="flex" alignItems={isMobile ? 'flex-start' : 'center'} flexDirection={isMobile ? 'column' : 'row'} gap={isMobile ? 8 : 16} padding={12} borderBottom="default" background="tint2" flexShrink={0}>
          <SelectField label="Collaboratore" value={selectedId} onChange={e => setSelectedId(e.target.value)} marginBottom={0} width={isMobile ? '100%' : 230}>
            <option value="tutti">Tutti i collaboratori</option>
            {collaboratorsList.map(u => <option key={u.id} value={String(u.id)}>{u.nome} {u.cognome}</option>)}
          </SelectField>
          {!isMobile && <Text size={300} color="muted">{allDays.length > 0 ? `Mese: ${new Date(`${allDays[0].fullDate}T12:00:00`).toLocaleDateString('it-IT', { month: 'long', year: 'numeric' })}` : ''}</Text>}
          <Pane flex={1} />
          <Pane display="flex" gap={8} width={isMobile ? '100%' : 'auto'}>
            <Button onClick={onClose} flex={isMobile ? 1 : undefined}>Chiudi</Button>
            <Button appearance="primary" onClick={handleDownload} disabled={loading} flex={isMobile ? 1 : undefined}>Scarica PDF</Button>
          </Pane>
        </Pane>
        <TurniPdfPreviewArea pdfUrl={pdfUrl} loading={loading} isMobile={isMobile} onDownload={handleDownload} />
      </div>
    </>,
    document.body
  );
}
